import { useEffect, useState } from "react";
import Chart from "react-google-charts";

const stateList = [
  {
    state_id: "TX",
    state_name: "Texas",
  },
  {
    state_id: "CT",
    state_name: "Connecticut",
  },
  {
    state_id: "DC",
    state_name: "District of Columbia",
  },
  {
    state_id: "DE",
    state_name: "Delaware",
  },
  {
    state_id: "IL",
    state_name: "Illinois",
  },
  {
    state_id: "MA",
    state_name: "Massachusetts",
  },
  {
    state_id: "MD",
    state_name: "Maryland",
  },
  {
    state_id: "ME",
    state_name: "Maine",
  },
  {
    state_id: "NH",
    state_name: "New Hampshire",
  },
  {
    state_id: "NJ",
    state_name: "New Jersey",
  },
  {
    state_id: "NY",
    state_name: "New York",
  },
  {
    state_id: "OH",
    state_name: "Ohio",
  },
  {
    state_id: "PA",
    state_name: "Pennsylvania",
  },
  {
    state_id: "RI",
    state_name: "Rhode Island",
  },
];

const USGeoMap = () => {
  const [data, setData] = useState<any>([["State", "Value"]]);

  useEffect(() => {
    if (!stateList) return;

    const newData = data.map((item: any) => [...item]);
    for (const state of stateList) {
      newData.push([state.state_name, 1]);
    }
    // const newData = data.map((item) => [...item]);

    // for (const state of stateList) {
    //   if (stateToUtility[state]) {
    //     const { value } = stateToUtility[state];

    //     newData.push([state, value]);
    //   }
    // }

    setData(newData);
  }, [stateList]);

  const options = {
    region: "US",
    displayMode: "regions",
    resolution: "provinces",
    tooltip: { trigger: "none" },
    legend: "none",
    colorAxis: { values: [1, 2], colors: ["#865ce2", "#865ce2"] },
    backgroundColor: "transparent",
    datalessRegionColor: "#f3f6f9",
  };

  if (data.length < 2) return null;
  return (
    <div id="geo-chart">
      <Chart
        chartType="GeoChart"
        width="100%"
        height="390px"
        data={data}
        options={options}
      />
    </div>
  );
};

export default USGeoMap;
